import {
  CreditCard,
  Link2,
  ListPlus,
  PanelLeftClose,
  PanelLeftOpen,
  PanelTop,
} from "lucide-react";
import { useState } from "react";
import type { Locale, TranslationKey } from "../i18n";
import { t } from "../i18n";
import type { AppView } from "../types/workspace";

type SaasNavigationProps = {
  locale: Locale;
  view: AppView;
  onNavigate: (view: AppView) => void;
};

const destinations: Array<{
  view: AppView;
  label: TranslationKey;
  icon: typeof PanelTop;
}> = [
  { view: "workspace", label: "workspace", icon: PanelTop },
  { view: "listings", label: "listings", icon: ListPlus },
  { view: "connections", label: "connections", icon: Link2 },
  { view: "billing", label: "billing", icon: CreditCard },
];

export function SaasNavigation({
  locale,
  view,
  onNavigate,
}: SaasNavigationProps) {
  const [collapsed, setCollapsed] = useState(false);
  const ToggleIcon = collapsed ? PanelLeftOpen : PanelLeftClose;
  const toggleLabel = t(
    locale,
    collapsed ? "expandNavigation" : "collapseNavigation",
  );

  return (
    <nav
      className={`saas-navigation${collapsed ? " is-collapsed" : ""}`}
      aria-label="Picasso"
    >
      <div className="saas-navigation-heading">
        <p>Picasso</p>
        <button
          className="saas-navigation-toggle"
          type="button"
          aria-label={toggleLabel}
          aria-expanded={!collapsed}
          onClick={() => setCollapsed((value) => !value)}
        >
          <ToggleIcon size={16} aria-hidden="true" />
        </button>
      </div>
      {destinations.map(({ view: destination, label, icon: Icon }) => (
        <button
          key={destination}
          className={view === destination ? "active" : ""}
          type="button"
          aria-label={t(locale, label)}
          aria-current={view === destination ? "page" : undefined}
          onClick={() => onNavigate(destination)}
        >
          <Icon size={16} aria-hidden="true" />
          <span className="saas-navigation-label">{t(locale, label)}</span>
          {collapsed && (
            <span className="saas-navigation-tooltip" aria-hidden="true">
              {t(locale, label)}
            </span>
          )}
        </button>
      ))}
    </nav>
  );
}
